import React, { useEffect, useState, useRef } from 'react'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import Button from '@mui/material/Button'

const SuccessPopup = (props) => {
  const { popupVisible, onPopupCancel, onPopupOk } = props

  const handlePopupClose = () => {
    onPopupCancel()
  }

  const handlePopupOk = () => {
    onPopupOk()
  }

  if (popupVisible) {
    return (
      <div
        className='confirm-dialog-main'
        onClick={() => {
          //   handlePopupClose()
        }}
      >
        <div className='confirm-dialog-container'>
          <CheckCircleOutlineRoundedIcon
            style={{
              width: '50px',
              height: '50px',
              color: '#42C54F'
            }}
          />
          <p
            className='confirm-dialog-label1'
            style={{
              color: '#42C54F'
            }}
          >
            You're done with this activity.
          </p>
          <p className='confirm-dialog-label2'>Would you like to submit now?</p>
          <p className='confirm-dialog-label2'>
            Please note if you hit submit, you will not be able to make any
            further changes.
          </p>
          <div className='confirm-dialog-button-container'>
            <Button
              variant='outlined'
              style={{
                height: '44px',
                width: '134px',
                borderColor: '#41C54F',
                color: '#41C54F',
                marginRight: '20px',
                borderRadius: '8px'
              }}
              onClick={() => {
                handlePopupClose()
              }}
            >
              Cancel
            </Button>
            <Button
              variant='contained'
              style={{
                height: '44px',
                width: '134px',
                backgroundColor: '#41C54F',
                borderRadius: '8px',
                color: '#ffffff'
              }}
              onClick={() => {
                handlePopupOk()
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export { SuccessPopup }
